import React from 'react';
import { businessInfo } from '../mock/data';

const About = () => {
  const rows = [
    {
      label: 'Agent',
      content: (
        <>
          <span className="font-bold text-[#152238] whitespace-nowrap">{businessInfo.agentName}</span>
          <span className="text-gray-700 whitespace-nowrap"> — {businessInfo.agentTitle}</span>
        </>
      )
    },
    {
      label: 'Phone',
      content: (
        <a 
          href={`tel:${businessInfo.phoneTel}`}
          className="text-[#3B5275] hover:text-[#152238] underline transition-colors"
        >
          {businessInfo.phone}
        </a>
      )
    },
    {
      label: 'Email',
      content: (
        <a 
          href={`mailto:${businessInfo.email}`}
          className="text-[#3B5275] hover:text-[#152238] underline transition-colors break-all"
        >
          {businessInfo.email}
        </a>
      )
    },
    {
      label: 'Location',
      content: <span className="text-gray-700">{businessInfo.location}</span>
    },
    {
      label: 'National Producer Number',
      content: <span className="text-gray-700 font-mono">{businessInfo.npn}</span>
    }
  ];

  return (
    <section className="py-16 bg-[#F5F5F8]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-[#152238] mb-8">
          About
        </h2>

        <div className="flex flex-col md:flex-row md:items-center gap-10 md:gap-12">
          <div className="space-y-3 flex-1 order-2 md:order-1">
            {rows.map((row, index) => (
              <div 
                key={index} 
                className="grid grid-cols-1 md:grid-cols-[260px_1fr] gap-1 md:gap-8 py-1"
              >
                <div className="text-gray-600 text-base">{row.label}</div>
                <div className="text-base">{row.content}</div>
              </div>
            ))}
          </div>

          <div className="order-1 md:order-2 flex justify-center md:justify-end flex-shrink-0 md:ml-auto">
            <img
              src="/agent-profile.png"
              alt={`${businessInfo.agentName}, ${businessInfo.agentTitle}`}
              data-testid="about-agent-photo"
              className="w-36 h-36 md:w-44 md:h-44 rounded-full object-cover object-top border-4 border-[#152238] shadow-lg"
            />
          </div>
        </div>

        {/* Compliance Note */}
        <div className="mt-8 bg-[#FDF6E3] border border-[#F0E5C8] rounded-lg p-5">
          <p className="text-gray-800 text-base">
            <span className="font-semibold">Compliance note:</span> We provide plan comparisons and enrollment assistance; availability varies by carrier and county.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
